import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const IadgPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#4D8BC9] to-[#1A3A5F] text-white">
        <div className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">IADG EXPERTS</h1>
            <p className="text-xl mb-8">
              Engenharia e Consultoria Industrial Especializada
            </p>
            <Link 
              to="/contato" 
              className="inline-block bg-white text-[#4D8BC9] font-bold px-8 py-3 rounded-md hover:bg-gray-100 transition-colors"
            >
              Solicitar Orçamento
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Sobre a Empresa */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="md:w-1/2"
            >
              <h2 className="text-3xl font-bold mb-6 text-[#4D8BC9]">Quem Somos</h2>
              <p className="text-lg text-gray-700 mb-4">
                A IADG EXPERTS é uma empresa especializada em engenharia e consultoria industrial, 
                com foco em projetos, cálculos, dimensionamento e análises de engenharia. Nossa equipe 
                de engenheiros e especialistas oferece soluções técnicas avançadas para otimização de 
                processos e equipamentos industriais.
              </p>
              <p className="text-lg text-gray-700 mb-4">
                Com mais de 10 anos de experiência no mercado, somos reconhecidos pela excelência técnica, 
                inovação e compromisso com a qualidade dos serviços prestados, atendendo aos mais altos 
                padrões nacionais e internacionais.
              </p>
              <p className="text-lg text-gray-700">
                Nossa missão é contribuir para o desenvolvimento tecnológico e a eficiência operacional 
                de nossos clientes, através de soluções de engenharia que garantam segurança, produtividade 
                e sustentabilidade.
              </p>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="md:w-1/2 bg-gray-100 p-8 rounded-lg"
            >
              <h3 className="text-2xl font-bold mb-4 text-[#4D8BC9]">Nossos Diferenciais</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <div className="bg-[#1A3A5F] rounded-full p-1 mt-1 mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#4D8BC9]">Expertise Técnica</h4>
                    <p className="text-gray-700">Equipe multidisciplinar com especialistas em diversas áreas da engenharia, garantindo soluções abrangentes e integradas.</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <div className="bg-[#1A3A5F] rounded-full p-1 mt-1 mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#4D8BC9]">Inovação Tecnológica</h4>
                    <p className="text-gray-700">Utilização de softwares avançados de modelagem, simulação e análise para desenvolvimento de projetos de alta complexidade.</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <div className="bg-[#1A3A5F] rounded-full p-1 mt-1 mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#4D8BC9]">Metodologia Própria</h4>
                    <p className="text-gray-700">Metodologia exclusiva de desenvolvimento de projetos, garantindo eficiência, qualidade e cumprimento de prazos.</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <div className="bg-[#1A3A5F] rounded-full p-1 mt-1 mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#4D8BC9]">Soluções Customizadas</h4>
                    <p className="text-gray-700">Desenvolvimento de soluções personalizadas para as necessidades específicas de cada cliente e projeto.</p>
                  </div>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Serviços */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#4D8BC9]">Nossos Serviços</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Oferecemos um portfólio completo de serviços de engenharia e consultoria industrial, 
              garantindo soluções técnicas avançadas para os mais diversos desafios.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Serviço 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#4D8BC9]">Projetos de Engenharia</h3>
                <p className="text-gray-700 mb-4">
                  Desenvolvimento de projetos de engenharia para equipamentos, sistemas e instalações industriais, 
                  incluindo projetos conceituais, básicos e detalhados.
                </p>
                <Link 
                  to="/servicos/engenharia" 
                  className="inline-flex items-center text-[#1A3A5F] font-semibold hover:underline"
                >
                  Saiba mais
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </motion.div>

            {/* Serviço 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                </svg>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#4D8BC9]">Cálculo e Dimensionamento</h3>
                <p className="text-gray-700 mb-4">
                  Cálculo e dimensionamento de equipamentos, estruturas e sistemas, incluindo análise de tensões, 
                  simulações numéricas e análise de elementos finitos.
                </p>
                <Link 
                  to="/servicos/calculo" 
                  className="inline-flex items-center text-[#1A3A5F] font-semibold hover:underline"
                >
                  Saiba mais
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </motion.div>

            {/* Serviço 3 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#4D8BC9]">Consultoria Técnica</h3>
                <p className="text-gray-700 mb-4">
                  Consultoria técnica especializada em diversas áreas da engenharia, incluindo análise de falhas, 
                  otimização de processos e melhoria de desempenho.
                </p>
                <Link 
                  to="/servicos/consultoria" 
                  className="inline-flex items-center text-[#1A3A5F] font-semibold hover:underline"
                >
                  Saiba mais
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </motion.div>

            {/* Serviço 4 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#4D8BC9]">Análise de Integridade</h3>
                <p className="text-gray-700 mb-4">
                  Análise de integridade estrutural, avaliação de vida remanescente, extensão de vida útil 
                  e gerenciamento da integridade baseado em risco (RBI).
                </p>
                <Link 
                  to="/servicos/integridade" 
                  className="inline-flex items-center text-[#1A3A5F] font-semibold hover:underline"
                >
                  Saiba mais
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </motion.div>

            {/* Serviço 5 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                </svg>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#4D8BC9]">Treinamento e Capacitação</h3>
                <p className="text-gray-700 mb-4">
                  Treinamentos e capacitações para engenheiros, técnicos e gestores, abordando temas como 
                  projetos, cálculos, normas técnicas e gestão de engenharia.
                </p>
                <Link 
                  to="/servicos/treinamento" 
                  className="inline-flex items-center text-[#1A3A5F] font-semibold hover:underline"
                >
                  Saiba mais
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </motion.div>

            {/* Serviço 6 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-[#4D8BC9]">Adequação a Normativas</h3>
                <p className="text-gray-700 mb-4">
                  Consultoria e assessoria para adequação de equipamentos, sistemas e instalações às normas 
                  técnicas e regulamentações aplicáveis.
                </p>
                <Link 
                  to="/servicos/normativas" 
                  className="inline-flex items-center text-[#1A3A5F] font-semibold hover:underline"
                >
                  Saiba mais
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </motion.div>
          </div>

          <div className="text-center mt-12">
            <Link 
              to="/servicos" 
              className="inline-block bg-[#4D8BC9] hover:bg-[#3A78B6] text-white font-bold px-8 py-3 rounded-md transition-colors"
            >
              Ver Todos os Serviços
            </Link>
          </div>
        </div>
      </section>

      {/* Setores Atendidos */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#4D8BC9]">Setores Atendidos</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Atendemos diversos setores industriais, oferecendo soluções personalizadas para as necessidades 
              específicas de cada segmento.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Setor 1 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Petróleo e Gás</h3>
              <p className="text-gray-700">
                Refinarias, plataformas, terminais, dutos e instalações de processamento.
              </p>
            </motion.div>

            {/* Setor 2 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Energia</h3>
              <p className="text-gray-700">
                Usinas termelétricas, hidrelétricas, nucleares e de energia renovável.
              </p>
            </motion.div>

            {/* Setor 3 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Química e Petroquímica</h3>
              <p className="text-gray-700">
                Indústrias químicas, petroquímicas, farmacêuticas e de cosméticos.
              </p>
            </motion.div>

            {/* Setor 4 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Papel e Celulose</h3>
              <p className="text-gray-700">
                Fábricas de papel, celulose e processamento de madeira.
              </p>
            </motion.div>

            {/* Setor 5 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Alimentos e Bebidas</h3>
              <p className="text-gray-700">
                Indústrias de alimentos, bebidas, laticínios e frigoríficos.
              </p>
            </motion.div>

            {/* Setor 6 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Siderurgia e Metalurgia</h3>
              <p className="text-gray-700">
                Usinas siderúrgicas, metalúrgicas e fundições.
              </p>
            </motion.div>

            {/* Setor 7 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Mineração</h3>
              <p className="text-gray-700">
                Mineradoras, beneficiamento de minérios e processamento mineral.
              </p>
            </motion.div>

            {/* Setor 8 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.7 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Outros Setores</h3>
              <p className="text-gray-700">
                Hospitais, shopping centers, hotéis, universidades e outros.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Certificações */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#4D8BC9]">Certificações e Qualificações</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Contamos com as principais certificações e qualificações do mercado, garantindo a qualidade 
              e confiabilidade dos nossos serviços.
            </p>
          </motion.div>

          <div className="flex flex-wrap justify-center gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center w-64">
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">ISO 9001</h3>
              <p className="text-gray-700">Sistema de Gestão da Qualidade</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center w-64">
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">ISO 14001</h3>
              <p className="text-gray-700">Sistema de Gestão Ambiental</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center w-64">
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">ISO 45001</h3>
              <p className="text-gray-700">Sistema de Gestão de Saúde e Segurança Ocupacional</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center w-64">
              <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">CREA</h3>
              <p className="text-gray-700">Conselho Regional de Engenharia e Agronomia</p>
            </div>
          </div>

          <div className="text-center mt-8">
            <Link 
              to="/certificacoes" 
              className="inline-flex items-center text-[#1A3A5F] font-semibold hover:underline"
            >
              Ver todas as certificações
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#4D8BC9] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Pronto para transformar seus desafios de engenharia em soluções?</h2>
            <p className="text-xl mb-8">
              Entre em contato conosco e solicite uma proposta personalizada para as necessidades da sua empresa.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link 
                to="/contato" 
                className="bg-white text-[#4D8BC9] hover:bg-gray-100 font-bold px-8 py-3 rounded-md transition-colors"
              >
                Solicitar Orçamento
              </Link>
              <Link 
                to="/servicos" 
                className="bg-transparent border-2 border-white hover:bg-white hover:text-[#4D8BC9] text-white font-bold px-8 py-3 rounded-md transition-colors"
              >
                Conhecer Serviços
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IadgPage;
